export default {
    path: '/',
    name: 'Login',
    component: resolve => require(['@/views/login'], resolve),
    redirect: '/login', 
    children: [
        {
            path: '/login',
            name: 'login',
            meta: [{
                path: '/login',
                title: '首页',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/login.vue'], resolve),
        },
    ],
}